import marker_icon from 'assets/images/svgs/marker-line-icon.svg';
import { Field, useFormikContext } from 'formik';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import AllInstitutesTypeaheadField from '../AllInstitutesTypeaheadField';
import { InstitutionServices } from 'utils/InstitutionServices';
import { useEffect } from 'react';
import { FAILED_TO_FETCH_DATA } from 'utils/Constants';

const JobHospitalEditModalForAdminUser = (props) => {
    const { modal, setModal } = props;
    const { values, setFieldValue } = useFormikContext();
    const handleSubmit = () => {
        setModal(false);
    }

    const getInstitutionInfo = (id) => {
        InstitutionServices.getInstitutionById(id)
            .then((response) => {
                const { status, data } = response;
                if (status === 200) {
                    console.log(data);
                    setFieldValue("mainItemName", data?.name);
                    setFieldValue("mainItemName", data?.name);
                } else {
                    console.log(FAILED_TO_FETCH_DATA);
                }
            })
    }

    useEffect(() => {
        getInstitutionInfo(values?.institutionDetail)
    }, [])

    return (
        <Modal isOpen={modal} toggle={() => setModal(!modal)} className="nex-model-v2 modal-dialog-scrollable modal-dialog-centered">
            <ModalHeader toggle={() => setModal(!modal)}>Edit mode</ModalHeader>
            <ModalBody>
                <>
                    <div className="nex-job-form-right-sec">
                        <Field
                            id="institutionDetail"
                            name="institutionDetail"
                            type="text"
                            label="Search for the Institution"
                            placeholder="Search and select"
                            component={AllInstitutesTypeaheadField}
                        />

                        {values?.institutionDetail && values?.mainItemName &&
                            <div
                                key={values?.institutionDetail}
                                className={`nex-radio-hospital active`}
                            >
                                <div className="info">
                                    <h3 className='nex-text-xl' >{values.mainItemName}</h3>
                                    <p className="nex-text text-black bold">
                                        <span className='icon'>
                                            <img src={marker_icon} alt="" />
                                        </span>
                                        {values.mainItemName}
                                    </p>
                                </div>
                            </div>
                        }
                    </div>
                </>
                <div className="form-group nex-action-flex">
                    <Button
                        id="nex-pa-about-submit-btn"
                        className="nex-btn-primary mr-2"
                        color="primary"
                        onClick={handleSubmit}
                    >
                        Save
                    </Button>
                    <Button
                        id="nex-pa-about-cancel-btn"
                        onClick={() => setModal(false)}
                        className="nex-btn-primary-outline"
                        color="primary"
                    >
                        Cancel
                    </Button>
                </div>
            </ModalBody>
        </Modal>
    )
}

export default JobHospitalEditModalForAdminUser;